import React, { useContext, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import axios from "axios";
import Header from "../Headers/Header";
import { useLanguage } from "../LanguageContext";
import { translations } from "./translation";
import logo from "../../assets/ar encyclopedy.png";
import { Language } from "../../Types/types";
import { getBaseUrl } from "../Manual_List/fetch/baseEndpoint";
import { ThemeContext } from "../../hooks/themeContext";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const { language } = useLanguage();
  const t = translations[language as Language];

  const { isDark } = useContext(ThemeContext);


  const handleLogin = async () => {
    try {
      const response = await axios.post(
        `${getBaseUrl()}/login`,
        {
          username,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (response.status === 200) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("username", response.data.user.username);

        const from = (
          location.state as { from?: { pathname: string; search: string } }
        )?.from;
        const storedRedirect = sessionStorage.getItem("redirectAfterLogin");
        sessionStorage.removeItem("redirectAfterLogin");

        const redirectTo = from
          ? `${from.pathname}${from.search || ""}`
          : storedRedirect || "/";

        navigate(redirectTo, { replace: true });
      } else {
        setError(true);
      }
    } catch (error) {
      setError(true);
    }
  };

  const handleLinkClick = (path: string) => {};

  return (
    <div className="min-h-screen flex flex-col bg-gray-100 relative z-10 transition-all">
      <div className="absolute w-full z-20 bg-white top-0 h-10">
        <Header hideLogo={true} />
      </div>

      {isDark ? (
        <img
          src="./gradient_background_dark.jpg"
          alt="hm"
          className="cover w-full h-screen"
        />
      ) : (
        <img
          src="./gradient_background.jpg"
          alt="hm"
          className="cover w-full h-screen"
        />
      )}
      <div className="flex flex-col items-center justify-center flex-grow absolute inset-0">
        <img
          src={logo}
          alt="AR ENCYCLOPEDY LOGO"
          className="h-12 w-auto mb-5 mt-4"
        />
        <form
          className="dark:bg-darkSecondaryBackground bg-white rounded-2xl sm:shadow-md sm:mb-20 sm:py-10 sm:px-16 p-4 max-w-lg flex flex-col justify-between min-h-96"
          onSubmit={(e) => {
            e.preventDefault();
            handleLogin();
          }}
        >
          <div>
            <div className="flex justify-center mb-4">
              <h1 className="font-semibold text-purple text-3xl">Login</h1>
            </div>
            <div className="mb-4">
              <label className="text-gray dark:text-white font-light">
                {t.usernamePlaceholder}
              </label>
              <input
                type="text"
                className={`w-full px-3 py-2 rounded-md border border-purple dark:bg-darkSecondaryBackground dark:text-white ${
                  error ? "border-red-500" : "border-gray-300"
                } outline-none`}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="mb-2">
              <label className="text-gray dark:text-white font-light">
                {t.passwordPlaceholder}
              </label>
              <input
                type="password"
                className={`w-full px-3 py-2 rounded-md border border-purple dark:bg-darkSecondaryBackground dark:text-white ${
                  error ? "border-red-500" : "border-gray-300"
                } outline-none`}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="flex justify-between items-center mb-4">
              {error && (
                <div className="text-red-600 text-left text-sm font-light">
                  {t.incorrectCredentials}
                </div>
              )}
            </div>
          </div>
          <div className="w-full py-10">
            <button
              type="submit"
              className="w-full bg-purple hover:bg-darkPurple text-white px-3 py-2 rounded-full font-medium transition-all"
            >
              {t.loginButton}
            </button>
          </div>
          <Link
            to="/forgotten-password"
            className="text-md text-purple text-center text-medium"
            onClick={() => handleLinkClick("/forgotten-password")}
          >
            {t.forgotPassword}
          </Link>
        </form>
      </div>
    </div>
  );
};

export default Login;
